<template>
    <el-aside class="aside" width="210px">
        <el-menu :default-active="active" active-text-color="#2196f3" class="menu" unique-opened>
            <el-submenu v-for="item in authMenu" :index="item.index" :key="item.index">
                <span slot="title">{{ item.name }}</span>
                <router-link v-for="child in item.children" :key="child.index" :to="child.path">
                    <el-menu-item :index="child.index">
                        {{
                        child.name
                        }}
                    </el-menu-item>
                </router-link>
            </el-submenu>
        </el-menu>
    </el-aside>
</template>

<script>
import { mapState } from 'vuex';
import { menu } from '../../router.js';

export default {
    data() {
        return {
            active: '1-1',
        };
    },
    computed: {
        ...mapState({
            role: (state) => state.userInfo.role,
            isAgent: (state) => !!state.userInfo.agentId,
        }),
        authMenu() {
            const level = menu
                .filter((item) => item.role.indexOf(this.role) > -1)
                .map((item) => {
                    item.children = item.children.filter(
                        (val) => val.role.indexOf(this.role) > -1
                    );
                    return item;
                });
            return level.filter(
                (item) => !(item.index === '3' && this.isAgent)
            );
        },
    },
    created() {
        const { path } = this.$route;
        let all = [];
        menu.forEach((item) => {
            all = [...all, ...item.children];
        });
        const route = all.find((item) => item.path === path);
        this.active = route.index;
    },
};
</script>

<style lang="less" scoped>
.menu {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
}
</style>
